module.exports = __webpack_public_path__ + "static/media/Status_Implementation.08d10701.svg";